var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-input",
        {
          staticClass: "input-with-select",
          staticStyle: { "line-hight": "40px" },
          attrs: {
            placeholder: "请选择",
            size: _vm.size,
            disabled: _vm.disabled,
            readonly: _vm.readonly,
          },
          model: {
            value: _vm.name,
            callback: function ($$v) {
              _vm.name = $$v
            },
            expression: "name",
          },
        },
        [
          _c("el-button", {
            attrs: {
              slot: "append",
              disabled: _vm.disabled,
              readonly: _vm.readonly,
              icon: "el-icon-search",
            },
            on: { click: _vm.showUserSelect },
            slot: "append",
          }),
        ],
        1
      ),
      _c("user-select", {
        ref: "userSelect",
        attrs: { limit: _vm.limit, selectData: _vm.selectData },
        on: { doSubmit: _vm.selectUsersToInput },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }